import { environment } from 'environments/environment';

export interface iSideBarMenuItem {
  code: string;
  legend: string;
  route: string;
  subRoute?: iSideBarMenuItem[];
  icon?: string;
  external?: boolean;
  permissionType?: 'EDITOR' | 'VISUALIZA';
}

const token: string = sessionStorage.getItem('token') as string;
export const adminPermissions: iSideBarMenuItem[] = [
  {
    code: 'INSTRUCTIONS',
    legend: 'SIDEBAR.INSTRUCTIONS',
    route: '/panel/instructions',
    icon: 'INSTRUCTIONS',
  },
  {
    code: 'CERTIFICATION-REQUEST',
    legend: 'SIDEBAR.CERTIFICATION-REQUEST',
    route: '/panel/certification-request',
    icon: 'CERTIFICATION-REQUEST',
    subRoute: [
      {
        code: 'PENDING',
        legend: 'SIDEBAR.PENDING',
        route: '/panel/certification-request/pending',
      },
      {
        code: 'PENDING-APROVE',
        legend: 'SIDEBAR.PENDING-APROVE',
        route: '/panel/certification-request/pending-approval',
      },
      {
        code: 'PENDING-INFO',
        legend: 'SIDEBAR.PENDING-INFO',
        route: '/panel/certification-request/pending-info',
      },
      {
        code: 'APPROVED',
        legend: 'SIDEBAR.APPROVED',
        route: '/panel/certification-request/approved',
      },
      {
        code: 'FAILED',
        legend: 'SIDEBAR.FAILED',
        route: '/panel/certification-request/failed',
      },
    ],
  }, 
  {
    code: 'CONFIG-REPORTS',
    legend: 'Emissão de Relatórios',
    route: '/panel/config-reports',
    icon: 'AUDITS',
    subRoute: []
  },
  {
    code: 'PERFORMANCE-REPORT',
    legend: 'Relatório de Performance',
    route: '/panel/performance-report',
    icon: 'PERFORMANCE',
    subRoute: []
  },
  {
    code: 'REGISTER',
    legend: 'SIDEBAR.REGISTER',
    route: '/panel/register',
    icon: 'REGISTER',
    subRoute: [
      {
        code: 'CLIENTS',
        legend: 'SIDEBAR.CLIENTS',
        route: '/panel/register/clients',
        icon: 'CLIENTS',
      },
      {
        code: 'MY-DATA',
        legend: 'SIDEBAR.MY-DATA',
        route: '/panel/register/my-data',
        icon: 'MY-DATA',
      },
      {
        code: 'USERS',
        legend: 'SIDEBAR.USERS',
        route: '/panel/register/users',
        icon: 'USER',
        subRoute: [
          {
            code: 'USERS-QIMA-ADMIN',
            legend: 'SIDEBAR.USERS-ADMIN',
            route: '/panel/register/users/admin',
            icon: 'USER',
          },
          {
            code: 'USERS-QIMA-REQUESTER',
            legend: 'SIDEBAR.USERS-CLIENT',
            route: '/panel/register/users/client',
            icon: 'USER',
          },
        ],
      },
      {
        code: 'SUPPLY',
        legend: 'SIDEBAR.SUPPLY',
        route: '/panel/register/supply',
        icon: 'SUPPLY',
      },
    ],
  },
  {
    code: 'CERTIFICATIONS',
    legend: 'SIDEBAR.CERTIFICATIONS',
    route: '/panel/schemes/certifications',
    subRoute: [
      {
        code: 'INSPECTION-PREPARATION',
        legend: 'SIDEBAR.PRE-INSPECTION',
        route: '/panel/schemes/certifications/inspection-preparation',
        subRoute: [
          {
            code: 'PENDING-INFO',
            legend: 'SIDEBAR.PENDING-INFO',
            route:
              '/panel/schemes/certifications/inspection-preparation/pending-info',
          },
          {
            code: 'PENDING-APROVE',
            legend: 'SIDEBAR.PENDING-APROVE',
            route:
              '/panel/schemes/certifications/inspection-preparation/pending-approval',
          },
        ],
      },
      {
        code: 'INSPECTION',
        legend: 'SIDEBAR.INSPECTION',
        route: '/panel/schemes/certifications/inspection',
        subRoute: [
          {
            code: 'PENDING-INFO',
            legend: 'SIDEBAR.PENDING-INFO',
            route: '/panel/schemes/certifications/inspection/pending-info',
          },
          {
            code: 'PENDING-APROVE',
            legend: 'SIDEBAR.PENDING-APROVE',
            route: '/panel/schemes/certifications/inspection/pending-approval',
          },
        ],
      },
      {
        code: 'INSPECTION-DECISION',
        legend: 'SIDEBAR.INSPECTION-DECISION',
        route: '/panel/schemes/certifications/inspection-decision',
        subRoute: [
          {
            code: 'APPROVED',
            legend: 'SIDEBAR.APPROVED',
            route: '/panel/schemes/certifications/inspection-decision/approved',
          },
          {
            code: 'FAILED',
            legend: 'SIDEBAR.FAILED',
            route: '/panel/schemes/certifications/inspection-decision/failed',
          },
        ],
      },
    ],
    icon: 'CERTIFICATIONS',
  },
  {
    code: 'CT-LIST',
    legend: 'CT',
    route: '/panel/schemes/ct',
    icon: 'PRODUCTS',
    subRoute: [
      // {
      //   code: 'INSPECTION-PREPARATION',
      //   legend: 'SIDEBAR.PRE-INSPECTION',
      //   route: '/panel/schemes/ct/inspection-preparation',
      //   subRoute: [
      //     {
      //       code: 'PENDING-INFO',
      //       legend: 'SIDEBAR.PENDING-INFO',
      //       route: '/panel/schemes/ct/inspection-preparation/pending-info',
      //     },
      //     {
      //       code: 'PENDING-APROVE',
      //       legend: 'SIDEBAR.PENDING-APROVE',
      //       route: '/panel/schemes/ct/inspection-preparation/pending-approval',
      //     },
      //   ],
      // },
      // {
      //   code: 'INSPECTION',
      //   legend: 'SIDEBAR.INSPECTION',
      //   route: '/panel/schemes/ct/inspection',
      //   subRoute: [
      //     {
      //       code: 'PENDING-INFO',
      //       legend: 'SIDEBAR.PENDING-INFO',
      //       route: '/panel/schemes/ct/inspection/pending-info',
      //     },
      //     {
      //       code: 'PENDING-APROVE',
      //       legend: 'SIDEBAR.PENDING-APROVE',
      //       route: '/panel/schemes/ct/inspection/pending-approval',
      //     },
      //   ],
      // },
      // {
      //   code: 'INSPECTION-DECISION',
      //   legend: 'SIDEBAR.INSPECTION-DECISION',
      //   route: '/panel/schemes/ct/inspection-decision',
      //   subRoute: [
      //     {
      //       code: 'APPROVED',
      //       legend: 'SIDEBAR.APPROVED',
      //       route: '/panel/schemes/ct/inspection-decision/approved',
      //     },
      //     {
      //       code: 'FAILED',
      //       legend: 'SIDEBAR.FAILED',
      //       route: '/panel/schemes/ct/inspection-decision/failed',
      //     },
      //   ],
      // },
    ],
  },
  {
    code: 'SELF-CONTROL',
    legend: 'SIDEBAR.SELF-CONTROL',
    route: '/panel/schemes/self-control',
    icon: 'AUDITS',
    subRoute: [
      // {
      //   code: 'INSPECTION-PREPARATION',
      //   legend: 'SIDEBAR.PRE-INSPECTION',
      //   route: '/panel/schemes/self-control/inspection-preparation',
      //   subRoute: [
      //     {
      //       code: 'PENDING-INFO',
      //       legend: 'SIDEBAR.PENDING-INFO',
      //       route:
      //         '/panel/schemes/self-control/inspection-preparation/pending-info',
      //     },
      //     {
      //       code: 'PENDING-APROVE',
      //       legend: 'SIDEBAR.PENDING-APROVE',
      //       route:
      //         '/panel/schemes/self-control/inspection-preparation/pending-approval',
      //     },
      //   ],
      // },
      // {
      //   code: 'INSPECTION',
      //   legend: 'SIDEBAR.INSPECTION',
      //   route: '/panel/schemes/self-control/inspection',
      //   subRoute: [
      //     {
      //       code: 'PENDING-INFO',
      //       legend: 'SIDEBAR.PENDING-INFO',
      //       route: '/panel/schemes/self-control/inspection/pending-info',
      //     },
      //     {
      //       code: 'PENDING-APROVE',
      //       legend: 'SIDEBAR.PENDING-APROVE',
      //       route: '/panel/schemes/self-control/inspection/pending-approval',
      //     },
      //   ],
      // },
      // {
      //   code: 'INSPECTION-DECISION',
      //   legend: 'SIDEBAR.INSPECTION-DECISION',
      //   route: '/panel/schemes/self-control/inspection-decision',
      //   subRoute: [
      //     {
      //       code: 'APPROVED',
      //       legend: 'SIDEBAR.APPROVED',
      //       route: '/panel/schemes/self-control/inspection-decision/approved',
      //     },
      //     {
      //       code: 'FAILED',
      //       legend: 'SIDEBAR.FAILED',
      //       route: '/panel/schemes/self-control/inspection-decision/failed',
      //     },
      //   ],
      // },
    ],
  },
  {
    code: 'NOTES',
    legend: 'SIDEBAR.NOTES',
    route: '/panel/schemes/notes',
    icon: 'MINERVA',
    subRoute: [
      // {
      //   code: 'INSPECTION-PREPARATION',
      //   legend: 'SIDEBAR.PRE-INSPECTION',
      //   route: '/panel/schemes/notes/inspection-preparation',
      //   subRoute: [
      //     {
      //       code: 'PENDING-INFO',
      //       legend: 'SIDEBAR.PENDING-INFO',
      //       route: '/panel/schemes/notes/inspection-preparation/pending-info',
      //     },
      //     {
      //       code: 'PENDING-APROVE',
      //       legend: 'SIDEBAR.PENDING-APROVE',
      //       route:
      //         '/panel/schemes/notes/inspection-preparation/pending-approval',
      //     },
      //   ],
      // },
      // {
      //   code: 'INSPECTION',
      //   legend: 'SIDEBAR.INSPECTION',
      //   route: '/panel/schemes/notes/inspection',
      //   subRoute: [
      //     {
      //       code: 'PENDING-INFO',
      //       legend: 'SIDEBAR.PENDING-INFO',
      //       route: '/panel/schemes/notes/inspection/pending-info',
      //     },
      //     {
      //       code: 'PENDING-APROVE',
      //       legend: 'SIDEBAR.PENDING-APROVE',
      //       route: '/panel/schemes/notes/inspection/pending-approval',
      //     },
      //   ],
      // },
      // {
      //   code: 'INSPECTION-DECISION',
      //   legend: 'SIDEBAR.INSPECTION-DECISION',
      //   route: '/panel/schemes/notes/inspection-decision',
      //   subRoute: [
      //     {
      //       code: 'APPROVED',
      //       legend: 'SIDEBAR.APPROVED',
      //       route: '/panel/schemes/notes/inspection-decision/approved',
      //     },
      //     {
      //       code: 'FAILED',
      //       legend: 'SIDEBAR.FAILED',
      //       route: '/panel/schemes/notes/inspection-decision/failed',
      //     },
      //   ],
      // },
    ],
  },
  {
    code: 'EVALUATIONS',
    legend: 'SIDEBAR.EVALUATIONS',
    route: '/panel/schemes/evaluations',
    icon: 'AUDITS',
    subRoute: [
      // {
      //   code: 'INSPECTION-PREPARATION',
      //   legend: 'Pré Avaliação',
      //   route: '/panel/schemes/evaluations/inspection-preparation',
      //   subRoute: [
      //     {
      //       code: 'PENDING-INFO',
      //       legend: 'SIDEBAR.PENDING-INFO',
      //       route: '/panel/schemes/evaluations/inspection-preparation/pending-info',
      //     },
      //     {
      //       code: 'PENDING-APROVE',
      //       legend: 'SIDEBAR.PENDING-APROVE',
      //       route:
      //         '/panel/schemes/evaluations/inspection-preparation/pending-approval',
      //     },
      //   ],
      // },
      // {
      //   code: 'INSPECTION',
      //   legend: 'SIDEBAR.INSPECTION',
      //   route: '/panel/schemes/evaluations/inspection',
      //   subRoute: [
      //     {
      //       code: 'PENDING-INFO',
      //       legend: 'SIDEBAR.PENDING-INFO',
      //       route: '/panel/schemes/evaluations/inspection/pending-info',
      //     },
      //     {
      //       code: 'PENDING-APROVE',
      //       legend: 'SIDEBAR.PENDING-APROVE',
      //       route: '/panel/schemes/evaluations/inspection/pending-approval',
      //     },
      //   ],
      // },
      // {
      //   code: 'INSPECTION-DECISION',
      //   legend: 'SIDEBAR.INSPECTION-DECISION',
      //   route: '/panel/schemes/evaluations/inspection-decision',
      //   subRoute: [
      //     {
      //       code: 'APPROVED',
      //       legend: 'SIDEBAR.APPROVED',
      //       route: '/panel/schemes/evaluations/inspection-decision/approved',
      //     },
      //     {
      //       code: 'FAILED',
      //       legend: 'SIDEBAR.FAILED',
      //       route: '/panel/schemes/evaluations/inspection-decision/failed',
      //     },
      //   ],
      // },
    ],
  },
  {
    code: 'SCHEME-REGISTER',
    legend: 'SIDEBAR.REGISTER-SCHEME',
    route: '/panel/schemes/register',
    icon: 'MY-DATA',
  },
  {
    code: 'OPERATIONS',
    legend: 'SIDEBAR.OPERATIONS-SCHEME',
    route: '/panel/schemes/operations',
    icon: 'MY-DATA',
  },
  {
    code: 'DOCUMENTS',
    legend: 'SIDEBAR.DOCUMENTS-SCHEME',
    route: '/panel/schemes/documents',
    icon: 'MY-DATA',
  },
  {
    code: 'SETTINGS',
    legend: 'SIDEBAR.SETTINGS',
    route: '/panel/settings',
    icon: 'SETTINGS',
    subRoute: [
      {
        code: 'ASSOCIATE',
        legend: 'SIDEBAR.ASSOCIATE',
        route: '/panel/settings/schemes',
        icon: 'ASSOCIATE',
      },
      {
        code: 'PROCESSES',
        legend: 'SIDEBAR.PROCESSES',
        route: '/panel/settings/processes',
        icon: 'CHECKLISTS',
      },
      {
        code: 'CHECKLISTS',
        legend: 'SIDEBAR.CHECKLISTS',
        route: '/panel/settings/checklists',
        icon: 'CHECKLISTS',
      },
      {
        code: 'LABEL-CONFIG',
        legend: 'SIDEBAR.LABEL-CONFIGURATION',
        route: '/panel/settings/label-config',
        icon: 'LABEL',
      },
      {
        code: 'MENU-CONFIGURATION',
        legend: 'SIDEBAR.MENU-CONFIGURATION',
        route: '/panel/settings/menu-system',
        icon: 'SETTINGS',
      },
    ],
  },
  {
    code: 'COMUNICATION',
    legend: 'SIDEBAR.COMMUNICATION',
    route: '/panel/comunication',
    icon: 'COMUNICATION',
  },
  {
    code: 'APPLICATIONS',
    legend: 'SIDEBAR.APPLICATIONS',
    route: '/panel/applications',
    icon: 'GLOBE',
    subRoute: [
      {
        code: 'SAFEGIS',
        legend: 'SIDEBAR.SAFEGIS',
        route: `${environment.gpaUrl}/#/login/${token}`,
        external: true,
      },
      {
        code: 'MASTERBOI',
        legend: 'SIDEBAR.MASTERBOI',
        route: `${environment.qualificacaoFornecedoresUrl}/#/safetrace/login/${token}`,
        external: true,
      },
    ],
  },
  {
    code: 'SUPPORT',
    legend: 'SIDEBAR.SUPPORT',
    route: '/panel/support',
    icon: 'SUPPORT',
  },
];

export const clientPermissions: iSideBarMenuItem[] = [
  {
    code: 'INSTRUCTIONS',
    legend: 'SIDEBAR.INSTRUCTIONS',
    route: '/client-panel/instructions',
    icon: 'INSTRUCTIONS',
  },
  {
    code: 'DASHBOARD',
    legend: 'SIDEBAR.DASHBOARD',
    route: '/client-panel/dashboard',
    icon: 'DASHBOARD',
  },
  {
    code: 'OPERATIONS',
    legend: 'SIDEBAR.OPERATIONS',
    route: '/client-panel/operations',
    icon: 'OPERATIONS',
    subRoute: [
      {
        code: 'PURCHASE-RECORD',
        legend: 'SIDEBAR.PURCHASE-RECORD',
        route: '/client-panel/operations/purchase-record',
        icon: 'PURCHASE-RECORD',
      },
      {
        code: 'SALES-RECORD',
        legend: 'SIDEBAR.SALES-RECORD',
        route: '/client-panel/operations/sales-record',
        icon: 'SALES-RECORD',
      },
      {
        code: 'PRODUCTION-ORDER',
        legend: 'SIDEBAR.PRODUCTION-ORDER',
        route: '/client-panel/operations/production-order',
        icon: 'PRODUCTS',
      },
      {
        code: 'STOCK',
        legend: 'SIDEBAR.STOCK',
        route: '/client-panel/operations/stock',
        icon: 'STOCK',
      },
    ],
  },
  {
    code: 'HOMOLOGATION-PROCESS',
    legend: 'SIDEBAR.HOMOLOGATION-PROCESS',
    route: '/client-panel/register/macroprocess/homologation-process',
    icon: 'MAIL',
    subRoute: [],
  },
  {
    code: 'CT',
    legend: 'SIDEBAR.CT',
    route: '/client-panel/ct',
    icon: 'MAIL',
    subRoute: [],
  },
  {
    code: 'EVALUATIONS',
    legend: 'SIDEBAR.EVALUATIONS',
    route: '/client-panel/evaluations',
    icon: 'AUDITS',
    subRoute: [],
  },
  {
    code: 'SCHEME-REGISTER',
    legend: 'SIDEBAR.REGISTER-SCHEME',
    route: '/client-panel/register-schemas',
    icon: 'PROVIDER',
    subRoute: [],
  },
  {
    code: 'OPERATIONS',
    legend: 'SIDEBAR.OPERATIONS-SCHEME',
    route: '/client-panel/scheme-operations',
    icon: 'GLOBE',
    subRoute: [],
  },
  {
    code: 'DOCUMENTS',
    legend: 'SIDEBAR.DOCUMENTS-SCHEME',
    route: '/client-panel/documents',
    icon: 'CHECKLISTS',
    subRoute: [],
  },
  {
    code: 'NOTES',
    legend: 'SIDEBAR.NOTES',
    route: '/client-panel/notes',
    icon: 'AUDITS',
    subRoute: [
      {
        code: 'SCHEMES',
        legend: 'SIDEBAR.SCHEMES',
        route: '/client-panel/notes/schemes',
      },
      {
        code: 'SELF-CONTROL',
        legend: 'SIDEBAR.SELF-CONTROL',
        route: '/client-panel/notes/self-control',
      },
    ],
  },
  {
    code: 'REGISTER',
    legend: 'SIDEBAR.REGISTER',
    route: '/client-panel/register',
    icon: 'REGISTER',
    subRoute: [
      {
        code: 'MY-DATA',
        legend: 'SIDEBAR.MY-DATA',
        route: '/client-panel/register/my-data',
        icon: 'MY-DATA',
      },
      {
        code: 'CLIENTS',
        legend: 'SIDEBAR.CLIENTS',
        route: '/client-panel/register/clients',
        icon: 'CLIENTS',
      },
      {
        code: 'PROVIDERS',
        legend: 'SIDEBAR.PROVIDERS',
        route: '/client-panel/register/providers',
        icon: 'PROVIDER',
      },
      {
        code: 'PRODUCTS',
        legend: 'SIDEBAR.PRODUCTS',
        route: '/client-panel/register/products',
        icon: 'PRODUCTS',
      },
      {
        code: 'USERS',
        legend: 'SIDEBAR.USERS',
        route: '/client-panel/register/users',
        icon: 'USER',
      },
      {
        code: 'SUPPLY',
        legend: 'SIDEBAR.SUPPLY',
        route: '/client-panel/register/supply',
        icon: 'SUPPLY',
      },
    ],
  },
  {
    code: 'SETTINGS',
    legend: 'SIDEBAR.SETTINGS',
    route: '/client-panel/register/macroprocess/associate',
    icon: 'SETTINGS',
    subRoute: [
      {
        code: 'ASSOCIATE',
        legend: 'SIDEBAR.ASSOCIATE',
        route: '/client-panel/register/macroprocess/associate',
        icon: 'ASSOCIATE',
      },
      {
        code: 'CHECKLISTS',
        legend: 'SIDEBAR.CHECKLISTS',
        route: '/client-panel/register/macroprocess/checklists',
        icon: 'CHECKLISTS',
      },
      {
        code: 'DATASHEET',
        legend: 'SIDEBAR.DATASHEET',
        route: '/client-panel/datasheet',
        icon: 'TECHNICAL_SHEET',
      },
      {
        code: 'PROCESSES',
        legend: 'SIDEBAR.PROCESSES',
        route: '/client-panel/processes',
        icon: 'CHECKLISTS',
      },
      {
        code: 'LABEL-CONFIG',
        legend: 'SIDEBAR.LABEL-CONFIGURATION',
        route: '/client-panel/label-config',
        icon: 'LABEL',
      },
    ],
  },
  {
    code: 'APPLICATIONS',
    legend: 'SIDEBAR.APPLICATIONS',
    route: '/client-panel/applications',
    icon: 'GLOBE',
    subRoute: [
      {
        code: 'SAFEGIS',
        legend: 'SIDEBAR.SAFEGIS',
        route: `${environment.gpaUrl}/#/login/${token}`,
        external: true,
      },
      {
        code: 'MASTERBOI',
        legend: 'SIDEBAR.MASTERBOI',
        route: `${environment.qualificacaoFornecedoresUrl}/#/safetrace/login/${token}`,
        external: true,
      },
    ],
  },
  {
    code: 'SUPPORT',
    legend: 'SIDEBAR.SUPPORT',
    route: '/client-panel/support',
    icon: 'SUPPORT',
  },
];
